// extracted by mini-css-extract-plugin
export var button = "ProductCard-module--button--018cf";
export var desktop = "ProductCard-module--desktop--09f3a";
export var header = "ProductCard-module--header--71a98";
export var illustration = "ProductCard-module--illustration--36faa";
export var illustrationOne = "ProductCard-module--illustrationOne--8b752";
export var illustrationThree = "ProductCard-module--illustrationThree--1f386";
export var illustrationTwo = "ProductCard-module--illustrationTwo--45021";
export var image = "ProductCard-module--image--d5ba9";
export var imageWrapper = "ProductCard-module--imageWrapper--ff3d0";
export var link = "ProductCard-module--link--a19ef";
export var links = "ProductCard-module--links--32bda";
export var mobile = "ProductCard-module--mobile--3466a";
export var root = "ProductCard-module--root--752a5";